import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const V_COLORS = { hot: '#ff4444', fast: '#ffaa00', normal: '#00ff88', slow: '#00d4ff', dead: '#606080' };

export default function VelocityGauge({ data }) {
  const [view, setView] = useState('daily');
  if (!data || !data.length) return <div className="inv-empty">No velocity data</div>;

  const display = data.slice(0, 20);
  const rateKey = view === 'daily' ? 'daily_rate' : view === 'weekly' ? 'weekly_rate' : 'monthly_rate';

  const barData = {
    labels: display.map(d => {
      const t = d.title.length > 20 ? d.title.slice(0, 20) + '…' : d.title;
      return d.variant_title && d.variant_title !== 'Default Title' ? `${t} (${d.variant_title})` : t;
    }),
    datasets: [{
      label: `${view.charAt(0).toUpperCase() + view.slice(1)} Sales Rate`,
      data: display.map(d => d[rateKey]),
      backgroundColor: display.map(d => V_COLORS[d.velocity_class] + '40'),
      borderColor: display.map(d => V_COLORS[d.velocity_class]),
      borderWidth: 2, borderRadius: 6, barPercentage: 0.6,
    }]
  };

  const options = {
    indexAxis: 'y', responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: 'rgba(22,22,42,0.95)', titleColor: '#fff', bodyColor: '#a0a0b0',
        callbacks: { afterBody: (ctx) => { const item = display[ctx[0].dataIndex]; return [`Class: ${item.velocity_class.toUpperCase()}`, `90d: ${item.units_90d} units, AED ${item.revenue_90d.toLocaleString()}`]; } }
      }
    },
    scales: {
      x: { grid: { color: 'rgba(255,255,255,0.03)' }, ticks: { color: '#a0a0b0', font: { size: 10 } } },
      y: { grid: { display: false }, ticks: { color: '#a0a0b0', font: { size: 10 } } }
    }
  };

  const dist = { hot: 0, fast: 0, normal: 0, slow: 0, dead: 0 };
  data.forEach(d => { if (dist[d.velocity_class] !== undefined) dist[d.velocity_class]++; });

  return (
    <div className="inv-chart-container">
      <h2 className="inv-chart-title">
        <span>⚡</span> Sales Velocity
        <span className="inv-badge">{data.length} active products</span>
      </h2>
      <div className="inv-velocity-dist">
        {Object.entries(dist).map(([cls, count]) => (
          <div key={cls} className="inv-velocity-badge" style={{ borderColor: V_COLORS[cls], color: V_COLORS[cls] }}>
            <span className="inv-badge-count">{count}</span>
            <span>{cls.toUpperCase()}</span>
          </div>
        ))}
      </div>
      <div className="inv-view-toggle">
        {['daily','weekly','monthly'].map(v => (
          <button key={v} className={view === v ? 'active' : ''} onClick={() => setView(v)}>
            {v.charAt(0).toUpperCase() + v.slice(1)}
          </button>
        ))}
      </div>
      <div style={{ height: `${display.length * 45 + 60}px`, position: 'relative' }}>
        <Bar data={barData} options={options} />
      </div>
    </div>
  );
}
